import React, { useState } from "react";
import Modal from "../../Modal";

export type ContextMenuEntry = {
  title: string;
  handleClick: (e: React.MouseEvent<HTMLElement>) => void;
  icon?: React.FC;
  disabled?: boolean;
  visible?: boolean;
  alert?: boolean;
  preventCloseOnClick?: boolean;
  promptLoading?: boolean;
  newSection?: boolean;
};

export type ContextMenuFocusedItem = {
  image: string | null;
  title: string;
  subtitle: string | null;
};

export type ContextMenuContent = {
  title: string;
  focusedItem: ContextMenuFocusedItem | false;
  menuContent: ContextMenuEntry[];
};

type Props = {
  setModalVisible: (prev: boolean) => void;
  menuData: ContextMenuContent;
  stopPropogationOnClose?: boolean;
}

const ContextMenu = ({setModalVisible, menuData, stopPropogationOnClose}: Props) => {
  
  const [isLoading, setIsLoading] = useState(false);

  const isEmpty = menuData.menuContent.filter(item => item.visible !== false).length === 0;
  
  return (
    <Modal
      setModalVisible={setModalVisible}
      controls
      bottomPane
      modalTitle={menuData.title}
      isLoading={isLoading}
      stopPropogationOnClose={stopPropogationOnClose}
      children={
        <div className="item-list large">
          {menuData.focusedItem &&
            <div className="item-row">
              {menuData.focusedItem.image && 
                <div className="thumb">
                  <img src={menuData.focusedItem.image} />
                </div>
              }
              <div className="item-list small">
                <p className="heading-small weight-light ellipsis-block">{menuData.focusedItem.title}</p>
                {menuData.focusedItem.subtitle && <p className="subtitle-medium secondary ellipsis">{menuData.focusedItem.subtitle}</p>}
              </div>
            </div>
          }
          <div className="item-list">
            {menuData.menuContent.map((item, i) => item.visible !== false &&
              <React.Fragment key={i}>
                {item.newSection && <div className="divider-line-horizontal subtle" />}
                <button aria-disabled={item.disabled} key={i} className={"text menu-entry"} data-alert={item.alert} onClick={(e) => {
                  if (item.disabled) return;
                  item.handleClick(e);
                  
                  if (item.promptLoading) {
                    setIsLoading(true);
                    return;
                  }
                  if (item.preventCloseOnClick) return;
                  setModalVisible(false);
                }}>
                  
                    <div className="item-row">
                      {item.icon && React.createElement(item.icon)}
                      {item.title}
                    </div>
                  
                </button>
              </React.Fragment>
            )}
            {isEmpty && <p className="body secondary center">No options</p>}
          </div>
        </div>
      }
    />
  )
}
export default ContextMenu;